<template>
  <div :class="[deviceType, 'inner']">
    <div :class="[deviceType, 'line']">
      <div class="content">
        <AcknowledgementSuccessSvg></AcknowledgementSuccessSvg>
      </div>
      <div class="top-up-successful">
        {{ t("ccOnBoarding.acknowledgement.success") }}
      </div>

      <div
        v-if="
          prop.creditLimit &&
          showCreditLimit(prop.creditLimit) &&
          preStatus != 'TIMEOUT' &&
          preStatus != 'DOWN'
        "
      >
        <div
          v-if="
            prop.isDraft ||
            (prop.dsr !== 'DECLINED' &&
              (prop.score || prop.type === 'PF_CC' || prop.type == 'EP_CC'))
          "
          class="wallet-limit-up-to-m"
        >
          {{ t("ccOnBoarding.acknowledgement.congrate") }}
        </div>
        <div v-else class="wallet-limit-up-to-m">
          {{ t("ccOnBoarding.acknowledgement.confirmation2") }}
        </div>
        <div
          v-if="
            prop.isDraft ||
            (prop.dsr !== 'DECLINED' &&
              (prop.score || prop.type === 'PF_CC' || prop.type == 'EP_CC'))
          "
          class="limit"
        >
          {{ t("ccOnBoarding.acknowledgement.rm") }}
          {{ formattedValue }}
        </div>
        <div
          v-if="
            prop.isDraft ||
            (prop.dsr !== 'DECLINED' &&
              (prop.score || prop.type === 'PF_CC' || prop.type == 'EP_CC'))
          "
          class="wallet-limit-up-to-m"
        >
          {{ t("ccOnBoarding.acknowledgement.confirmation1") }}
        </div>
        <div class="refNo">
          {{ t("ccOnBoarding.acknowledgement.refNo") }} {{ prop.refNo }}
        </div>
        <div
          v-if="
            prop.isDraft ||
            (prop.dsr !== 'DECLINED' &&
              (prop.score || prop.type === 'PF_CC' || prop.type == 'EP_CC'))
          "
          class="subject"
        >
          {{ t("ccOnBoarding.acknowledgement.subject") }}
        </div>
      </div>
      <div v-else>
        <div class="refNo">
          {{ t("ccOnBoarding.acknowledgement.refNo") }} {{ prop.refNo }}
        </div>
        <div class="noLimit">
          {{ t("ccOnBoarding.acknowledgement.wellDone") }}
        </div>
      </div>
      <VirutalCCBar :ack="ack"></VirutalCCBar>
    </div>
    <!-- product bundling desktop -->
    <div
      v-if="
        deviceType != 'Mobile' &&
        prop.type == 'PF_CC' &&
        !prop.changeApplicationFlag
      "
      class="pf_content"
    >
      <div v-if="deviceType != 'Mobile'" class="pf_innerContent">
        <div v-if="deviceType != 'Mobile'" class="wallet-limit-up-to-m pf-con">
          <h2>{{ t("ccOnBoarding.acknowledgement.insurance1") }}</h2>
          <p>{{ t("ccOnBoarding.acknowledgement.insurance2") }}</p>
        </div>
        <div class="pf_rightContent">
          <div class="insurance_img">
            <img
              style="width: 195px; height: 195px"
              class=""
              src="../../../../assets/icons/insurance.svg"
            />
          </div>
          <div class="insurance_content">
            <h2>{{ t("ccOnBoarding.acknowledgement.insurance3") }}</h2>
            <div class="insurance_desc">
              <p>
                {{ t("ccOnBoarding.acknowledgement.insurance_content1_eng") }}
              </p>
              <p>
                {{ t("ccOnBoarding.acknowledgement.insurance_content1_bm") }}
              </p>
            </div>
            <div class="insurance_desc">
              <p>
                {{ t("ccOnBoarding.acknowledgement.insurance_content2_eng") }}
              </p>
              <p>
                {{ t("ccOnBoarding.acknowledgement.insurance_content2_bm") }}
              </p>
            </div>
            <div class="insurance_desc">
              <p>
                {{ t("ccOnBoarding.acknowledgement.insurance_content3_eng") }}
              </p>
              <p>
                {{ t("ccOnBoarding.acknowledgement.insurance_content3_bm") }}
              </p>
            </div>
            <div class="insurance_desc">
              <p>
                {{ t("ccOnBoarding.acknowledgement.insurance_content4_eng") }}
              </p>
              <p>
                {{ t("ccOnBoarding.acknowledgement.insurance_content4_bm") }}
              </p>
            </div>

            <div :class="[deviceType, 'buttoncontainer']">
              <button
                :class="[deviceType, 'right-button']"
                @click="submitInsurance()"
                :disabled="isSubmit"
              >
                <span v-if="!isSubmit">
                  {{ t("ccOnBoarding.acknowledgement.signMeUp") }}</span
                >
                <span v-else class="insideButton">
                  <div
                    class="spinner-border"
                    role="status"
                    style="width: 16px; height: 16px"
                  >
                    <span class="sr-only">{{
                      t("ccOnBoarding.uploadDocument.loading2")
                    }}</span>
                  </div>
                  {{ t("ccOnBoarding.uploadDocument.loading2") }}</span
                >
              </button>
              <div class="help" v-if="error">
                {{ t("ccOnBoarding.uploadDocument.loadingErrorMsg1") }}<br />{{
                  t("ccOnBoarding.uploadDocument.loadingErrorMsg2")
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="deviceType != 'Mobile'" class="pf_innerContent2">
        <div v-if="deviceType != 'Mobile'" class="wallet-limit-up-to-m pf-con">
          <h2>{{ t("ccOnBoarding.acknowledgement.footer1") }}</h2>
          <p>{{ t("ccOnBoarding.acknowledgement.footer2") }}</p>
        </div>
        <div v-if="deviceType != 'Mobile'" class="pf_qr_content">
          <div class="container">
            <div class="flex_forty">
              <div class="qr">
                {{ t("ccOnBoarding.acknowledgement.qr") }}
              </div>
              <div class="contentQR">
                <div class="frame-36347">
                  <QRCodeVue
                    :value="appqr"
                    :size="120"
                    level="L"
                    renderAs="svg"
                  />
                </div>
              </div>
            </div>
            <!-- <div class="flex_ten">
          <p class="or">{{ t("ccOnBoarding.acknowledgement.or") }}</p>
        </div> -->
            <div class="flex_forty">
              <div class="qr">
                {{ t("ccOnBoarding.acknowledgement.orDownload") }}
              </div>
              <div class="store">
                <a
                  :href="playstore"
                  target="_blank"
                  class="link"
                  style="margin-bottom: 17px; margin-top: 5%"
                >
                  <div class="frame-36380">
                    <div class="google-play-logo">
                      <img
                        style="width: 23px; height: 30px"
                        class="path-64"
                        src="../../../../assets/icons/Google_play.svg"
                      />
                    </div>
                    <div class="frame-363802">
                      <div class="upper-text">
                        <AcknowledgementGooglePlaySvg></AcknowledgementGooglePlaySvg>
                      </div>
                      <AcknowledgementGooglePlaySvg2></AcknowledgementGooglePlaySvg2>
                    </div>
                  </div>
                </a>
              </div>
              <div class="store">
                <a :href="appstore" target="_blank" class="link">
                  <div class="frame-363792">
                    <div class="apple-logo">
                      <img
                        style="width: 23px; height: 30px"
                        class="path-65"
                        src="../../../../assets/icons/Apple_logo.svg"
                      />
                    </div>
                    <div class="text">
                      <div class="download-text">
                        <AcknowledgementAppleStoreSvg></AcknowledgementAppleStoreSvg>
                      </div>
                      <div class="app-store-text">
                        <AcknowledgementAppleStoreSvg2></AcknowledgementAppleStoreSvg2>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="
        deviceType != 'Mobile' &&
        (prop.type != 'PF_CC' || prop.changeApplicationFlag)
      "
    >
      <div v-if="deviceType != 'Mobile'" class="wallet-limit-up-to-m">
        {{ t("ccOnBoarding.acknowledgement.footer") }}
      </div>
      <div v-if="deviceType != 'Mobile'" class="content">
        <div class="container">
          <div class="flex_forty">
            <div class="qr">
              {{ t("ccOnBoarding.acknowledgement.qr") }}
            </div>
            <div class="contentQR">
              <div class="frame-36347">
                <QRCodeVue
                  :value="appqr"
                  :size="120"
                  level="L"
                  renderAs="svg"
                />
              </div>
            </div>
          </div>
          <!-- <div class="flex_ten">
          <p class="or">{{ t("ccOnBoarding.acknowledgement.or") }}</p>
        </div> -->
          <div class="flex_forty">
            <div class="qr">
              {{ t("ccOnBoarding.acknowledgement.orDownload") }}
            </div>
            <div class="store">
              <a
                :href="playstore"
                target="_blank"
                class="link"
                style="margin-bottom: 17px; margin-top: 5%"
              >
                <div class="frame-36380">
                  <div class="google-play-logo">
                    <img
                      style="width: 23px; height: 30px"
                      class="path-64"
                      src="../../../../assets/icons/Google_play.svg"
                    />
                  </div>
                  <div class="frame-363802">
                    <div class="upper-text">
                      <AcknowledgementGooglePlaySvg></AcknowledgementGooglePlaySvg>
                    </div>
                    <AcknowledgementGooglePlaySvg2></AcknowledgementGooglePlaySvg2>
                  </div>
                </div>
              </a>
            </div>
            <div class="store">
              <a :href="appstore" target="_blank" class="link">
                <div class="frame-363792">
                  <div class="apple-logo">
                    <img
                      style="width: 23px; height: 30px"
                      class="path-65"
                      src="../../../../assets/icons/Apple_logo.svg"
                    />
                  </div>
                  <div class="text">
                    <div class="download-text">
                      <AcknowledgementAppleStoreSvg></AcknowledgementAppleStoreSvg>
                    </div>
                    <div class="app-store-text">
                      <AcknowledgementAppleStoreSvg2></AcknowledgementAppleStoreSvg2>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- product bundling mobile -->
    <div
      v-if="
        deviceType == 'Mobile' &&
        prop.type == 'PF_CC' &&
        !prop.changeApplicationFlag
      "
    >
      <div style="margin: 0 10%; border-top: 1px solid #e4e4e4">
        <div class="wallet-limit-up-to-m" :class="[deviceType, 'pf-con']">
          <h2>{{ t("ccOnBoarding.acknowledgement.insurance1") }}</h2>
          <p>{{ t("ccOnBoarding.acknowledgement.insurance2") }}</p>
        </div>
        <div class="insurance_img">
          <img
            style="width: 195px; height: 195px"
            class=""
            src="../../../../assets/icons/insurance.svg"
          />
        </div>
        <div :class="[deviceType, 'insurance_content']">
          <h2>{{ t("ccOnBoarding.acknowledgement.insurance3") }}</h2>
          <div class="insurance_desc">
            <p>
              {{ t("ccOnBoarding.acknowledgement.insurance_content1_eng") }}
            </p>
            <p>
              {{ t("ccOnBoarding.acknowledgement.insurance_content1_bm") }}
            </p>
          </div>
          <div class="insurance_desc">
            <p>
              {{ t("ccOnBoarding.acknowledgement.insurance_content2_eng") }}
            </p>
            <p>
              {{ t("ccOnBoarding.acknowledgement.insurance_content2_bm") }}
            </p>
          </div>
          <div class="insurance_desc">
            <p>
              {{ t("ccOnBoarding.acknowledgement.insurance_content3_eng") }}
            </p>
            <p>
              {{ t("ccOnBoarding.acknowledgement.insurance_content3_bm") }}
            </p>
          </div>
          <div class="insurance_desc">
            <p>
              {{ t("ccOnBoarding.acknowledgement.insurance_content4_eng") }}
            </p>
            <p>
              {{ t("ccOnBoarding.acknowledgement.insurance_content4_bm") }}
            </p>
          </div>

          <div :class="[deviceType, 'buttoncontainer2']">
            <button
              :class="[deviceType, 'right-button']"
              @click="submitInsurance()"
              :disabled="isSubmit"
            >
              <span v-if="!isSubmit">
                {{ t("ccOnBoarding.acknowledgement.signMeUp") }}</span
              >
              <span v-else class="insideButton">
                <div
                  class="spinner-border"
                  role="status"
                  style="width: 16px; height: 16px"
                >
                  <span class="sr-only">{{
                    t("ccOnBoarding.uploadDocument.loading2")
                  }}</span>
                </div>
                {{ t("ccOnBoarding.uploadDocument.loading2") }}</span
              >
            </button>
            <div class="help" v-if="error">
              {{ t("ccOnBoarding.uploadDocument.loadingErrorMsg1") }}<br />{{
                t("ccOnBoarding.uploadDocument.loadingErrorMsg2")
              }}
            </div>
          </div>
        </div>
      </div>
      <div class="wallet-limit-up-to-m">
        {{ t("ccOnBoarding.acknowledgement.downloadMobile") }}
      </div>
      <div :class="[deviceType, 'buttoncontainer']">
        <div class="store">
          <a :href="playstore" target="_blank" class="link">
            <div class="frame-36380">
              <div class="google-play-logo">
                <img
                  style="width: 23px; height: 30px"
                  class="path-64"
                  src="../../../../assets/icons/Google_play.svg"
                />
              </div>
              <div class="frame-363802">
                <div class="upper-text">
                  <AcknowledgementGooglePlaySvg></AcknowledgementGooglePlaySvg>
                </div>
                <AcknowledgementGooglePlaySvg2></AcknowledgementGooglePlaySvg2>
              </div>
            </div>
          </a>
        </div>
        <div class="store">
          <a :href="appstore" target="_blank" class="link">
            <div class="frame-363792">
              <div class="apple-logo">
                <img
                  style="width: 23px; height: 30px"
                  class="path-65"
                  src="../../../../assets/icons/Apple_logo.svg"
                />
              </div>
              <div class="text">
                <div class="download-text">
                  <AcknowledgementAppleStoreSvg></AcknowledgementAppleStoreSvg>
                </div>
                <div class="app-store-text">
                  <AcknowledgementAppleStoreSvg2></AcknowledgementAppleStoreSvg2>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div
      v-if="
        deviceType == 'Mobile' &&
        (prop.type != 'PF_CC' || prop.changeApplicationFlag)
      "
    >
      <div class="wallet-limit-up-to-m">
        {{ t("ccOnBoarding.acknowledgement.downloadMobile") }}
      </div>
      <div :class="[deviceType, 'buttoncontainer']">
        <div class="store">
          <a :href="playstore" target="_blank" class="link">
            <div class="frame-36380">
              <div class="google-play-logo">
                <img
                  style="width: 23px; height: 30px"
                  class="path-64"
                  src="../../../../assets/icons/Google_play.svg"
                />
              </div>
              <div class="frame-363802">
                <div class="upper-text">
                  <AcknowledgementGooglePlaySvg></AcknowledgementGooglePlaySvg>
                </div>
                <AcknowledgementGooglePlaySvg2></AcknowledgementGooglePlaySvg2>
              </div>
            </div>
          </a>
        </div>
        <div class="store">
          <a :href="appstore" target="_blank" class="link">
            <div class="frame-363792">
              <div class="apple-logo">
                <img
                  style="width: 23px; height: 30px"
                  class="path-65"
                  src="../../../../assets/icons/Apple_logo.svg"
                />
              </div>
              <div class="text">
                <div class="download-text">
                  <AcknowledgementAppleStoreSvg></AcknowledgementAppleStoreSvg>
                </div>
                <div class="app-store-text">
                  <AcknowledgementAppleStoreSvg2></AcknowledgementAppleStoreSvg2>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import i18n from "@/plugin/i18n";
import MasterService from "@/service/restfulService/CCOnboardMasterService";
import { computed, ref, onBeforeMount, onMounted } from "vue";
import Constants from "@/constants/constants";
import { deviceDetect } from "mobile-device-detect";
import QRCodeVue from "qrcode.vue";
import AcknowledgementSuccessSvg from "@/assets/icons/AcknowledgementSuccessSvg.vue";
import AcknowledgementGooglePlaySvg from "@/assets/icons/AcknowledgementGooglePlaySvg.vue";
import AcknowledgementGooglePlaySvg2 from "@/assets/icons/AcknowledgementGooglePlaySvg2.vue";
import AcknowledgementAppleStoreSvg from "@/assets/icons/AcknowledgementAppleStoreSvg.vue";
import AcknowledgementAppleStoreSvg2 from "@/assets/icons/AcknowledgementAppleStoreSvg2.vue";
import VirutalCCBar from "./VirutalCCBar.vue";

const playstore = Constants.PLAY_STORE;
const appstore = Constants.APPSTORE;
const appqr = Constants.APP_QR;
const { t } = i18n.global;
const deviceType = ref("");
const ack = ref(true);

onMounted(() => {
  const { isMobile, isTablet } = deviceDetect();

  if (isMobile) {
    deviceType.value = "Mobile";
  } else if (isTablet) {
    deviceType.value = "Tablet";
  } else {
    deviceType.value = "Desktop";
  }
});

const prop = defineProps({
  status: {
    type: String,
  },
  webFormRequestId: {
    type: String,
  },
  cardId: {
    type: String,
  },
  icNo: {
    type: String,
  },
  creditLimit: {
    type: String,
  },
  refNo: {
    type: String,
  },
  cardName: {
    type: String,
    required: true,
  },
  score: {
    type: String,
    required: true,
  },
  dsr: {
    type: String,
    required: true,
  },
  type: {
    type: String,
  },
  preStatus: {
    type: String,
  },
  changeApplicationFlag: {
    type: Boolean,
  },
  token: {
    type: String,
    required: true,
  },
  isDraft: {
    type: Boolean,
  },
});
const formattedValue = ref("");
const creditLimit = ref(Number(prop.creditLimit));
const formatValue = () => {
  // Format the value with two decimal places and commas for thousands
  formattedValue.value = creditLimit.value.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
const showCreditLimit = (value: string): boolean => {
  return Number(value) >= 1000.0;
};

const isSubmit = ref(false);
const error = ref(false);

const submitInsurance = () => {
  isSubmit.value = true;
  error.value = false;
  const requestModel = {
    webFormRequestId: prop.webFormRequestId,
  };

  MasterService.insuranceSubmit(requestModel)
    .then((res) => {
      if (res.status == 200) {
        const redirectUrl = res.data.responseModel.redirectUrl;
        window.open(redirectUrl, "_blank");
        isSubmit.value = false;
      }
    })
    .catch((e) => {
      isSubmit.value = false;
      error.value = true;
    });
};
onBeforeMount(() => {
  formatValue();
});
</script>

<style scoped>
.progressContainer {
  padding: 4% 8%;
  background: #fff;
}

.container {
  display: flex;
  width: 100%;
  align-items: center;
  text-align: center;
  gap: 8px;
  align-self: stretch;
  padding: 0;
  margin-bottom: 10px;
}

.flex_forty {
  width: 50%;
}

.flex_ten {
  width: 10%;
}

.store {
  display: flex;
  justify-content: center;
}

.content {
  display: flex;
  justify-content: center;
  margin: 0;
  padding: 0 20%;
}

.or {
  font: 500 16px/130% "Outfit";
  color: #9e9e9e;
  margin-bottom: 0;
}

.contentQR {
  display: flex;
  justify-content: center;
  margin: 10px 0 0 0;
}

.qr {
  font: 500 18px/130% "Outfit";
  color: #757575;
}

.top-up-successful,
.top-up-successful * {
  margin-top: 20px;
  box-sizing: border-box;
}
.top-up-successful {
  color: var(--primary-active, #ac2887);
  text-align: center;
  font: 500 22px/130% "outfit";
  position: relative;
  align-self: stretch;
}

.wallet-limit-up-to-m,
.wallet-limit-up-to-m * {
  box-sizing: border-box;
  margin-top: 16px;
}
.wallet-limit-up-to-m {
  color: var(--web-black-high, #212121);
  font: 500 18px/130% "Outfit";
  text-align: center;
  position: relative;
}

.wallet-limit-up-to-m h2 {
  color: var(--Web-Black-High, #212121);
  text-align: center;

  /* H1 */
  font-family: Outfit;
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 28.6px */
  margin: 0;
}

.wallet-limit-up-to-m p {
  color: var(--Web-Black-Medium, #757575);
  text-align: center;
  margin-top: 0;
  /* H3 */
  font-family: Outfit;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 23.4px */
}

.limit {
  margin-top: 16px;
  color: var(--web-black-high, #212121);
  font: 500 34px/130% "Outfit";
  text-align: center;
  position: relative;
}

.subject {
  margin-top: 16px;
  color: #757575;
  font: 500 14px/130% "Outfit";
  text-align: center;
  position: relative;
}

.line {
  padding: 0 10% 40px 10%;
  border-bottom: 1px solid #e4e4e4;
}

.line:is(.Mobile) {
  padding: 0 10% 20px 10%;
  border-bottom: none;
}

.frame-36347,
.frame-36347 * {
  box-sizing: border-box;
}
.frame-36347 {
  border-radius: 10.72px;
  display: flex;
  flex-direction: row;
  gap: 0px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  max-width: 200px;
  max-height: 200px;
  position: relative;
}

.image-9,
.image-9 * {
  box-sizing: border-box;
}
.image-9 {
  flex-shrink: 0;
  width: 120%;
  max-width: 180px;
  height: 120%;
  max-height: 180px;
  position: relative;
}

.frame-36380 {
  background: #000000;
  border-radius: 6.4px;
  border-style: solid;
  border-color: var(--line-break, #e4e4e4);
  border-width: 0.61px;
  display: flex;
  flex-direction: row;
  gap: 6.4px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 128px;
  height: 45px;
  position: relative;
}
.link {
  display: block;
  width: 128px;
}
.google-play-logo {
  flex-shrink: 0;
  width: 17.07px;
  height: 18.57px;
  position: relative;
  transform-origin: 0 0;
  transform: rotate(0deg) scale(1.25, 1.25);
  transform: translateY(90%);
}
.path-64 {
  height: auto;
  position: absolute;
  right: 44.15%;
  left: -0.01%;
  width: 55.86%;
  bottom: 0.35%;
  top: 1.28%;
  height: 98.37%;
  transform: translate(0px, -22.62px);
  overflow: visible;
}

.path-65 {
  height: auto;
  position: absolute;
  right: 44.15%;
  left: -0.01%;
  width: 55.86%;
  bottom: 0.35%;
  top: 1.28%;
  height: 98.37%;
  transform: translate(0px, -5px);
  overflow: visible;
}

.frame-363802 {
  display: flex;
  flex-direction: column;
  gap: 4.89px;
  align-items: flex-start;
  justify-content: flex-start;
  flex-shrink: 0;
  position: relative;
}
.upper-text {
  flex-shrink: 0;
  width: 35.9px;
  height: 5.66px;
  position: relative;
  margin-left: 3px;
}
.group-213 {
  height: auto;
  position: absolute;
  right: 0%;
  left: -0.01%;
  width: 100.01%;
  bottom: -0.03%;
  top: 0.03%;
  height: 100%;
  overflow: visible;
}
.frame-36379 {
  flex-shrink: 0;
  width: 78.36px;
  height: 15.37px;
  position: relative;
  overflow: visible;
}
.frame-363792 {
  background: #000000;
  border-radius: 6.4px;
  border-style: solid;
  border-color: var(--line-break, #e4e4e4);
  border-width: 0.61px;
  display: flex;
  flex-direction: row;
  gap: 6.4px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 128px;
  height: 45px;
  position: relative;
}
.apple-logo {
  flex-shrink: 0;
  width: 19.21px;
  height: 23.03px;
  position: relative;
}
.apple-logo2 {
  height: auto;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 27px;
  height: 30px;
  overflow: visible;
}
.text {
  display: flex;
  flex-direction: column;
  gap: 4.9px;
  align-items: center;
  justify-content: flex-start;
  flex-shrink: 0;
  position: relative;
}
.download-text {
  flex-shrink: 0;
  width: 71.77px;
  height: 6.3px;
  position: relative;
}
.download-text2 {
  height: auto;
  position: absolute;
  right: 0.01%;
  left: -0.01%;
  width: 100%;
  bottom: 0.03%;
  top: -0.03%;
  height: 100%;
  overflow: visible;
}
.app-store-text {
  flex-shrink: 0;
  width: 73.82px;
  height: 15.72px;
  position: relative;
}
.app-store-text2 {
  height: auto;
  position: absolute;
  right: 0%;
  left: 0%;
  width: 100%;
  bottom: -0.04%;
  top: 0.04%;
  height: 100.01%;
  overflow: visible;
}

.refNo {
  color: var(--web-black-high, #212121);
  text-align: center;
  font-family: var(--h-3-font-family, "Outfit", sans-serif);
  font-size: var(--h-3-font-size, 18px);
  line-height: var(--h-3-line-height, 130%);
  font-weight: var(--h-3-font-weight, 500);
  position: relative;
  align-self: stretch;
  margin-top: 16px;
}
.noLimit {
  margin-top: 16px;
  color: var(--web-black-medium, #757575);
  text-align: center;
  font-family: var(--subtitle-1-medium-font-family, "Outfit", sans-serif);
  font-size: var(--subtitle-1-medium-font-size, 16px);
  line-height: var(--subtitle-1-medium-line-height, 130%);
  font-weight: var(--subtitle-1-medium-font-weight, 500);
  position: relative;
  align-self: stretch;
}

.cardName {
  color: rgba(0, 0, 0, 0.68);
  font: 500 16px/130% "Outfit";
  margin-top: 16px;
  position: relative;
  align-self: stretch;
  text-align: center;
}

@media (max-width: 500px) {
}

.buttoncontainer:is(.Mobile) {
  gap: 10px;
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
  margin-top: 24px;
}

.left-button:is(.Mobile) {
  flex: 0 0 30%;
}

.right-button:is(.Mobile) {
  flex: 0 0 68%;
}

.inner:is(.Mobile) {
  padding: 20px 20px 0 20px;
}

.insurance_content h2 {
  color: var(--Web-Black-High, #212121);

  /* Subtitle 1 (Medium) */
  font-family: Outfit;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 20.8px */
}

.insurance_desc {
  margin-bottom: 10px;
}

.insurance_desc p:first-child {
  display: list-item;
}

.insurance_desc p {
  color: var(--Web-Black-Medium, #757575);
  /* Caption 2 */
  font-family: Outfit;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 15.6px */
  margin: 0 0 0 20px;
}

.pf-con {
  height: 100px;
}

.right-button {
  width: 100%;
  height: 32px;
  padding: 8px 16px;
  border-radius: 24px;
  border: none;
  background-image: var(
    --gradient-set-active,
    linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
  );
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pf_qr_content {
  display: flex;
  justify-content: center;
  margin: 0;
  padding: 0 10%;
}

.pf_content {
  display: flex;
  margin-top: 40px;
}

.pf_innerContent {
  flex: 1;
  padding-right: 24px;
  border-right: 1px solid #e4e4e4;
}

.pf_innerContent2 {
  flex: 1;
  padding-left: 24px;
}

.pf_rightContent {
  display: flex;
  gap: 30px;
  min-height: 265px;
}

.insurance_img {
  display: flex;
  align-items: center;
  justify-content: center;
}

.pf_qr_content .qr {
  color: var(--Web-Black-Medium, #757575);
  text-align: center;

  /* Caption 2 */
  font-family: Outfit;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 15.6px */
}

@media (max-width: 1024px) {
  .pf_rightContent {
    display: block;
  }

  .pf-con {
    margin-bottom: 20px;
  }

  .pf_qr_content .container {
    display: block;
  }

  .pf_qr_content .flex_forty:first-child {
    margin-bottom: 20px;
  }

  .pf_qr_content .flex_forty {
    width: 100%;
  }
}

@media (max-width: 750px) {
  .pf-con {
    height: 150px;
  }
}

.pf-con:is(.Mobile) {
  height: auto;
}

.insurance_content:is(.Mobile) {
  padding: 20px 0 0 0;
  border-bottom: 1px solid #e4e4e4;
}

.buttoncontainer2:is(.Mobile) {
  margin-bottom: 24px;
  justify-content: center;
  margin-top: 24px;
}

.right-button:disabled {
  width: 100%;
  height: 32px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background: #dedede;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
}

.right-button:disabled:is(.Desktop, .Tablet) {
  flex: 0 0 68%;
}

.right-button:is(.Mobile):disabled {
  width: 100%;
  height: 32px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background: #dedede;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 68%;
}

.insideButton {
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--black-medium-54, rgba(0, 0, 0, 0.54));
}

.help {
  color: red;
  margin-bottom: 0px;
  font: 500 12px/130% "Outfit";
  word-wrap: break-word;
  white-space: pre-wrap;
  text-align: center;
}
</style>
